import Vue from "vue";
import Router from "vue-router";
// 首页
const Home = resolve => require(["views/Home.vue"], resolve);
// Create
const Create = resolve => require(["views/Create.vue"], resolve);
//404页面
const notfound = resolve => require(["views/404.vue"], resolve);
const download = resolve => require(["views/download.vue"], resolve)
// 福利
const welfare = resolve => require(["views/mainpage/welfare.vue"], resolve);
/* 关于 */
// 用户注册协议
const userAgree = resolve => require(["views/about/userAgree.vue"], resolve);
const userAgree1 = resolve => require(["views/about/userAgree1.vue"], resolve);
const privacy = resolve => require(["views/about/privacy.vue"], resolve);
const privacy1 = resolve => require(["views/about/privacy1.vue"], resolve);
const logout = resolve => require(["views/about/logout.vue"], resolve);
const logout1 = resolve => require(["views/about/logout1.vue"], resolve);


// 作品管理
const authorIndex = resolve => require(["views/authorCenter/index"], resolve);
const authorInfo = resove => require(["views/authorInfo/index"], resove);
const authorIncome = resove => require(["views/authorIncome/index"], resove);
const messagecenter = resolve =>
    require(["views/messagecenter/index"], resolve);
const chapterList = resolve =>
    require(["views/authorCenter/secondLevel/chapterlist"], resolve);
const chapterManage = resolve =>
  require(["views/authorCenter/secondLevel/index"], resolve);
// const applypublic = resolve =>
//     require(["views/authorCenter/secondLevel/public"], resolve);
const contract = resolve =>
    require(["views/authorCenter/secondLevel/contract"], resolve);
// const completing = resolve =>
//     require(["views/authorCenter/secondLevel/completing"], resolve);
// const reward = resolve =>
//     require(["views/authorCenter/secondLevel/reward"], resolve);
// const chapterincome = resolve =>
//     require(["views/authorCenter/secondLevel/chapterincome"], resolve);
// const chapterdel = resolve =>
//     require(["views/authorCenter/secondLevel/chapterdel"], resolve);

const authorNewChapter = resolve =>
  require(["views/authorCenter/secondLevel/newChapter"], resolve);
Vue.use(Router);
import { getToken } from "utils/storage";
const router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/", // 首页
      name: "home",
      component: Home,
      meta: {
        // keepAlive: true,
        title: "黑岩故事会 - 首页"
      }
    },

    {
      path: "/welfare",
      name: "welfare",
      component: welfare,
      meta: {
        keepAlive: true,
        title: "黑岩故事会 - 福利"
      }
    },
    {
      path: "/download", // 下载
      name: "Download APP",
      component: download,
      meta: {
        keepAlive: true,
        title: "黑岩故事会 - 小程序"
      }
    },
    {
      path: "/author",
      name: "Stories",
      component: authorIndex,
      meta: {
        // keepAlive: true,
        // islogin: true,
        isAuthor: true,
        title: "黑岩故事会 - 作家中心",
        // icon: require('@/assets/author/Stroy-title-icon.png')
      },
    },
    {
        path: "/author/create/:id", // 首页
        name: "Create",
        component: Create,
        meta: {
          keepAlive: false,
          title: "黑岩故事会 - 创建作品"
        }
      },
    {
      path: "/author/authorManage",
      name: "Stories",
      component: chapterManage,
      redirect: "/author",
      meta: {
        // keepAlive: true,
        islogin: true,
        isAuthor: true,
        title: "黑岩故事会 - 作品信息",
        // icon: require('@/assets/author/Stroy-title-icon.png')
      },
      children: [
        {
          path: "chapterList/:id",
          name: "Chapter list",
          component: chapterList,
          islogin: true,
          meta: {
            title: "黑岩故事会 - 章节列表",
            isAuthor: true
          }
        },
        {
          path: "newChapter/:id/:chapterId",
          // path: "newChapter/:id/:chapterid/:allowPrice",
          name: "New Chapter",
          component: authorNewChapter,
          islogin: true,
          meta: {
            title: "黑岩故事会 - 章节内容",
            isAuthor: true
          }
        },
       /* {
          path: "public/:id",
          name: "Submit for review",
          component: applypublic,
          islogin: true,
          meta: {
            keepAlive: false,
            title: "Apply for public",
            isAuthor: true
          }
        },*/
        {
          path: "contract/:id",
          name: "Apply for contract",
          islogin: true,
          component: contract,
          meta: {
            title: "黑岩故事会 - 作者签约",
            isAuthor: true
          }
        },
        // {
        //   path: "completing/:id",
        //   name: "Apply for completion",
        //   component: completing,
        //   islogin: true,
        //   meta: {
        //     title: "Apply for completion",
        //     isAuthor: true
        //   }
        // },
        // {
        //   path: "reward/:id",
        //   name: "Apply for bonus",
        //   component: reward,
        //   islogin: true,
        //   meta: {
        //     title: "Apply for bonus",
        //     isAuthor: true
        //   }
        // },
        // {
        //   path: "chapterincome/:id",
        //   name: "Apply For Income",
        //   component: chapterincome,
        //   islogin: true,
        //   meta: {
        //     title: "Apply For Income",
        //     isAuthor: true
        //   }
        // },
        // {
        //   path: "chapterdel/:id",
        //   name: "Delete the story",
        //   component: chapterdel,
        //   islogin: true,
        //   meta: {
        //     title: "Delete the story",
        //     isAuthor: true
        //   }
        // },
      ]
    },
    {
      path: "/author/income",
      name: "Income",
      component: authorIncome,
      meta: {
        // keepAlive: true,
        islogin: true,
        // isAuthor: true,
        title: "黑岩故事会 - 收益信息",
        // icon: require('@/assets/author/Income-title-icon.png')
      }
    },
    {
      path: "/author/info",
      name: "Profile",
      component: authorInfo,
      meta: {
        // keepAlive: true,
        islogin: true,
        // isAuthor: true,
        title: "黑岩故事会 - 个人信息",
        // icon: require('@/assets/author/info-title-icon.png')
      }
    },
    {
      path: "/author/message",
      name: "Inbox",
      component: messagecenter,
      meta: {
        // keepAlive: true,
        islogin: true,
        isAuthor: true,
        title: "黑岩故事会 - 我的消息",
        // icon: require('@/assets/author/Comments-title-icon.png')
      },
    },
    {
      path: "*",
      name: "notfound",
      component: notfound,
      meta: {
        keepAlive: true,
        title: "页面不存在"
      }
    },
    {
      path: "/userAgree",
      name: "userAgree",
      component: userAgree,
      meta: {
        keepAlive: true,
        title: "《用户协议》"
      }
    },
    {
      path: "/userAgree1",
      name: "userAgree1",
      component: userAgree1,
      meta: {
        keepAlive: true,
        title: "User Services Agreement"
      }
    },
    {
      path: "/privacy",
      name: "privacy",
      component: privacy,
      meta: {
        keepAlive: true,
        title: "《隐私协议》"
      }
    },
    {
      path: "/privacy1",
      name: "privacy1",
      component: privacy1,
      meta: {
        keepAlive: true,
        title: "User Agreement Privacy Policy"
      }
    },
    {
      path: "/logout",
      name: "logout",
      component: logout,
      meta: {
        keepAlive: true,
        title: "注销协议"
      }
    },
    {
      path: "/logout1",
      name: "logout1",
      component: logout1,
      meta: {
        keepAlive: true,
        title: "注销协议"
      }
    },

  ]
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  window.scrollTo(0,0)
  if (to.meta.islogin && !getToken()) {
    //true则需要登录
    // router.push('/')
    next({
      name: "home",
      query: {
        redirect: to.fullPath
      }
    });
    return;
  } else {
    // if (to.meta.isAuthor) {
    //   if (getwriter() != "true") {
    //     next({
    //       name: "applyWriter",
    //       query: {
    //         redirect: to.fullPath
    //       }
    //     });
    //   } else {
    //     next();
    //   }
    // } else {
    //   next();
    // }
    next();
  }
});
export default router;
